import type { QuotesPricingType } from '@/lib/services/Jeeves/pricing/getProductPricing'
import { getOverridePricing } from '@/lib/services/Jeeves/pricing/getOverridePricing'
import { useEffect } from 'react'
import useGlobalStore from '../../../store/useGlobalStore'

export const useGetOverwriteTerms = () => {
  const {
    user: { customerType, customer },
    overwriteItems,
    setOverwriteItems,
    app: { alpha2, marketExceptions },
  } = useGlobalStore()

  const fetchAndOverridePricing = async () => {
    try {
      const overrideData = await getOverridePricing({
        userId: customer?.id.unicity,
        skus: marketExceptions?.skuPricingOverrides,
        alpha2,
      })

      return overrideData
    } catch (error) {
      console.error('Error fetching override pricing:', error)
      return null
    }
  }

  useEffect(() => {
    ;(async () => {
      if (customerType !== 'Associate') return
      if (overwriteItems.length > 0) return

      const overrideData = await fetchAndOverridePricing()

      if (overrideData) {
        setOverwriteItems(overrideData)
      }
    })()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerType])

  return { fetchAndOverridePricing }
}

export const useLoadProductOverwrittenTerms = () => {
  const { overwriteItems } = useGlobalStore()

  const getAssociatePricingData = (value: QuotesPricingType) => {
    if (overwriteItems) {
      const overwriteItem = overwriteItems.find(
        (item) => item.item.id.unicity === value?.sku,
      )
      if (overwriteItem) {
        const associateLevel = value?.levels.find(
          (level) => level.customer === 'Associate',
        )

        if (associateLevel) {
          associateLevel.terms = {
            ...associateLevel.terms,
            ...overwriteItem.terms,
          }
        }
        return value
      }
    }
    return value
  }

  return { getAssociatePricingData }
}
